/* eslint-disable import/prefer-default-export */

import * as types from '../constants/officeRunnerConstants'

export const requestStateInfo = () => (
  { type: types.REQUEST_STATE_INFO }
)

export const receiveStateInfo = stateInfo => (
  { type: types.RECEIVE_STATE_INFO, stateInfo }
)

export const fetchStateInfo = stateCode => {
  return dispatch => {
    dispatch(requestStateInfo())
    return fetch(`${process.env.REACT_APP_CE_API_ROOT}/states/${stateCode}`, {
      method: 'get',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-api-key': process.env.REACT_APP_API_KEY,
      }
    })
    .then(response => {
      if (!response.ok) {
        return Promise.reject(response.statusText)
      }
      return response.json()
    })
    .then(json => dispatch(receiveStateInfo(json)))
  }
}



// WEBPACK FOOTER //
// ./src/actions/apiActionCreators.js